import { OuvrageDto } from "../../structure/ouvrage/entities/ouvrage-dto.entity";

import { CommunicationMutuelleInfoEntity } from "./communication-mutuelle-info.entity";
import { EntrepriseExterieureEntity } from "./entreprise-exterieure.entity";
import { NouveauRisqueEntity } from "./nouveau-risque.entity";
import { RepresentantEntity } from "./representant.entity";
import { SignatairePdpEntity } from "./signataire-pdp.entity";
import { TraductionDto } from "./traduction-pdp.dto";
import { TravauxPdpEntity } from "./travaux-pdp.entity";
import { ValidateurEntity } from "./validateur.entity";
import { ValideurSignataireEntity } from "./valideur-signataire.entity";

export enum EtatPdp {
	A_FAIRE_SIGNER,
	SIGNE,
	SIGNE_PARTIELLEMENT,
	BROUILLON,
	ENVOYE_VIA_DOCUSIGN,
}

export enum TypePdp {
    GENERAL = "GENERAL",
    SPECIFIQUE = "SPECIFIQUE"
}

export class PlanPreventionEntity {
	id!: number;
	numeroPdp!: string;
	annee!: number;
	parcIds: number[] = [];
	ouvrages: OuvrageDto[] = [];
	autre!: string;
	typePdp!: number;
	lien!: string;
	description!: string;
	nombreIntervenants!: number;
	duree!: number;
	finValidite!: number[];
	debutValidite!: number[];
	actif!: boolean;
	travaux: TravauxPdpEntity[] = [];
	
	raisonSociale!: string;
	adresseEU!: string;
	telFax!: string;
	referentParcId!: number;
	nomPrenomReferent!: string;
	emailReferent!: string;
	fonctionReferent!: string;
	telephoneReferent!: string;
	emailGenerique!: string;
	astreinte!: string[];
	
	entreprisesExterieures: EntrepriseExterieureEntity[] = [];
	communicationMutuelleInfo: CommunicationMutuelleInfoEntity[] = [];
	riskActivities: TraductionDto[] = [];
	risks: TraductionDto[] = [];
	riskMesures: TraductionDto[] = [];
	impactActivities: TraductionDto[] = [];
	impacts: TraductionDto[] = [];
	impactMesures: TraductionDto[] = [];
	dateInspectionCommunePrealable!: number[] | null;
	valideurs: ValidateurEntity[] = [];
	valideurSignataires: ValideurSignataireEntity[] = [];
	nouveauxRisques: NouveauRisqueEntity[] = [];
	signataires: SignatairePdpEntity[] = [];
	representants: RepresentantEntity[] = [];
	classeOuvrageIds: number[] = [];
	groupementIds: number[] = [];
	antenneId!: number;
	obsolete!: boolean;
	etat!: number;
	parcCodes!: string;
	parcDescription!: string;
	versionTechnique!: number;
	lastCompletedStep: number = 0;
	
	expired!: boolean;
	parcActif!: boolean;
	mode!: string;
	idOuvrages!: string;
	nomEntreprises!: string;
	idEntreprises!: string;
	nomOuvrages!: string;
	agenceId!: number;

	constructor() { }
}